import { Component, OnInit } from '@angular/core';
import { RouterLink }          from '@angular/router';

@Component({
    selector: 'preregister-modal',
    templateUrl: './preregister-modal.component.html'
})
export class PreregisterModalComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
